import React, {useEffect,useState,useRef,useContext} from 'react';
import $ from 'jquery';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import { Link ,useNavigate} from 'react-router-dom';
import './css/App.css';
import Select from 'react-select';
import RefreshContext from './RefreshContext';
import ActivityLogModal from './ActivitiyLogModal';

axios.defaults.withCredentials = true;
function Category(){

const { refreshKey } = useContext(RefreshContext);
const [logOpen, setLogOpen] = useState(false); 
const [selectedIndex, setSelectedIndex] = useState(null);
const [staff, setStaff] = useState([]);
const [selectedExp, setSelectedExp] = useState(null);
const [total,setTotal]= useState(0);
const [add, setAdd] = useState(0);
 const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const searchRef = useRef(null);


const navigate = useNavigate();

$("#modalclose").on("click",function (){
  $("#submitform input").val("");
}); 

const fetchData = async () => {
  const response = await axios.get(apiurl+'app.php?subdomain=react'); // Replace with your API endpoint
   setStaff(response.data.staff);
   setTotal(response.data.total);
   setAdd(response.data.add);
   
};
useEffect(() => {
  document.title="Create App || MERAQUI";
        fetchData();
}, [refreshKey]);

const iconList = [
  "ri-whatsapp-fill",
  "ri-instagram-fill",
  "ri-facebook-fill",
  "ri-twitter-fill",
  "ri-linkedin-fill",
  "ri-telegram-fill",
  "ri-messenger-fill",
  "ri-discord-fill",
  "ri-reddit-fill",
  "ri-youtube-fill",
  "ri-snapchat-fill",
  "ri-skype-fill",
  "ri-slack-fill",
  "ri-wechat-fill",

  // E-commerce & services
  "ri-amazon-fill",
  "ri-shopping-cart-2-fill",
  "ri-paypal-fill",
  "ri-google-play-fill",
  "ri-app-store-fill",
  "ri-store-2-fill",
  "ri-bank-card-fill",
  "ri-wallet-3-fill",

  // Mobile & OS
  "ri-android-fill",
  "ri-apple-fill",
  "ri-windows-fill",
  "ri-mac-fill",
  "ri-chrome-fill",
  "ri-edge-fill",
  "ri-firefox-fill",
  "ri-safari-fill",

  // Dev / Tech tools
  "ri-github-fill",
  "ri-gitlab-fill",
  "ri-stack-overflow-fill",
  "ri-code-s-slash-line",
  "ri-terminal-box-fill",
  "ri-braces-line",
  "ri-brackets-line",
  "ri-flutter-fill",
  "ri-reactjs-fill",
  "ri-vuejs-fill",
  "ri-angularjs-fill",
  "ri-html5-fill",
  "ri-css3-fill",
  "ri-database-2-fill",

  // Generic App UI icons
  "ri-dashboard-fill",
  "ri-settings-5-fill",
  "ri-apps-fill",
  "ri-window-fill",
  "ri-layout-grid-fill",
  "ri-menu-fill",
  "ri-notification-3-fill",
  "ri-chat-3-fill",
  "ri-calendar-event-fill",
  "ri-camera-fill",
  "ri-music-2-fill",
  "ri-video-fill",
  "ri-map-pin-2-fill",
  "ri-image-fill",
  "ri-book-open-fill",
  "ri-gamepad-fill",
  "ri-mail-fill",
  "ri-folder-fill",
  "ri-file-text-fill",
  "ri-upload-cloud-2-fill",
  "ri-download-cloud-2-fill",
];


const options = iconList.map(icon => {
const cleanName = icon
  .replace(/^ri-/, "")
  .replace(/-fill$|-line$/, "")
  .replace(/-/g, " ")
  .replace(/\b\w/g, l => l.toUpperCase());
  return {
    value: icon,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <i className={`${icon} fs-18`}></i>
        <span>{cleanName}</span>
      </div>
    )
  };
});

// form submit in category
const FormSubmit = async (e) =>{
          e.preventDefault();
          
          // try and catch method
            try {
              const formData = new FormData($('#submitform')[0]); // get all form input values
              
              formData.append("icon",selectedExp?.value);

              const response = await axios.post(apiurl+"app.php", formData, {
               header:{
                    'Content-Type': 'multipart/form-data'
                },
              });
             
              //setSuccessMessage(response.data.message); // Set success message
              if (response.data.status==true) {
               
                                      Swal.fire({
                                        position: "top-center",
                                        icon: "success",
                                        title: response.data.message,
                                        showConfirmButton: false,
                                        timer: 2000
                                    }).then(()=>{
                                      $("#reset, #modalclose").click();
                                      $("#hidden").val("");
                                    fetchData();
                                    });
              }
              else{
                Swal.fire({
                                        position: "top-center",
                                        icon: "error",
                                        title: response.data.message,
                                        showConfirmButton: false,
                                        timer: 2000
                                    });
              }
            } catch (error) {
              console.log("error bhai ",error.response?.data?.message); // Handle errors with informative messages
            }
};
// delete the data from the category
const DeleteData = async (id) =>{
   if(!id){return false;}
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this data!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
  });

  if (result.isConfirmed) {
  try{
    const response = await axios.get(apiurl+"app.php?del="+id);
    if (response.data.status ==true) {
                                    Swal.fire({
                                        position: "top-center",
                                        icon: "success",
                                        title: response.data.message,
                                        showConfirmButton: false,
                                        timer: 2000
                                    }).then(()=>{
                                      fetchData();
                                    });
  
    }
    else{
      console.log(response.data.message);
    }
  }
  catch(error){
    console.error('Error deleting category:', error);
  }


}
  
};
//edit the form
const EditData = async (edit) =>{
   if(edit){
  try{
    const response = await axios.get(apiurl+'app.php?edit='+edit);

    if(response.data.status==true){
      $('#addStaffbtn').click();
      $("#name").val(response.data.name);
      $("#status").val(response.data.statuss);
      $("#hidden").val(response.data.hidden);
     
    }else{
      // modal can't show
      alert("data not found");
    }
    
  }
  catch(error){
    console.error('Error deleting category:', error);
  }

}
  
};

function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

searchRef.current = debounce((value) => {
  setLoading(true);

  setTimeout(() => {
    const items = document.querySelectorAll('.bhai1');
    let found = false;

    items.forEach((item) => {
      const name = item.querySelector('.body-text')?.textContent?.toLowerCase() || '';
      const match = name.includes(value);
      item.style.display = match ? 'block' : 'none';
      if (match) found = true;
    });

    document.getElementById("noDataMessage").style.display = found ? 'none' : 'block';

    setLoading(false);
  }, 300);
}, 300);

const handleChange = (e) => {
const value = e.target.value.toLowerCase().trim();
setSearchText(value);
searchRef.current(value);
};

const showLink = (id, url, okay) => {
const extra = okay ? `/${okay}` : "";
navigate(`/admin/${url}/${id}${extra}`);
};

return(
<>
<ActivityLogModal
  isOpen={logOpen}
  onClose={() => setLogOpen(false)}
  index={selectedIndex}
  apiurl={apiurl}
  subdomain="react"
/>

<span id="edit_output"></span>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel1" style={{display:'none'}} aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div className="modal-dialog">
        <div className="modal-content">
            <div className="modal-header">
                <h6 className="modal-title" id="exampleModalLabel1">Add App</h6>
                <button type="button" className="btn-close" data-bs-dismiss="modal" id="modalclose" aria-label="Close"></button>
            </div>
           <form id="submitform" onSubmit={FormSubmit}>
            <div className="modal-body">


<div  className="row g-3">
  <div className='col-xl-6'>
            <label htmlFor='profiles' className='form-label'>Select Icon</label>
            <Select
        options={options}
        value={selectedExp}
        onChange={setSelectedExp}
        isSearchable
        placeholder="Select Icon..."
        formatOptionLabel={option => option.label} 
      />
          </div>
          <div className="col-lg-6">
                       <label htmlFor="status" className="form-label">Status</label>
                      <select  id="status" name="status" className="form-control" autoComplete='off' required defaultValue="">
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                      </select>
                </div>
          		<div className="col-lg-12" >
                     {/* Category Input */}
                     <label htmlFor="name" className="form-label">Name</label>
                      <input  id="name" name="name" className="form-control" autoComplete='off'  placeholder='Application Name' required defaultValue=""/>
                </div>
                
                
              
      </div>

            </div>
            <div className='modal-footer' style={{padding:'0px'}}>
              <input type="hidden" name="hidden" id="hidden" />
              <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{marginRight:'20px',display:'none'}}/>
            <button type="submit" className="btn btn-primary">Submit</button>
            </div>
          </form>  
          </div>
        </div>
    </div>


<div className="main-content app-content">
                 
 <div className="container-fluid">

<div class="card custom-card mb-0">
    <div class="card-body">
        <div class="d-flex align-items-center flex-wrap gap-2">
            <h5 class="fw-semibold mb-0 flex-grow-1">{total} APP match for your search</h5>
            
            
            <div class="btn-group" style={{width:'25%'}}>
              <input type="search" onChange={handleChange} value={searchText} className="form-control" placeholder="Search App"/>
        
                <button class="btn btn-primary border dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">Sort By</button>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="javascript:void(0);">Newest</a></li>
                    <li><a class="dropdown-item" href="javascript:void(0);">Fresher</a></li>
                    <li><a class="dropdown-item" href="javascript:void(0);">Experienced</a></li>
                </ul>

                
            </div>
             {/* {(add==='1') && (
            <button data-tooltip-id="global-tooltip" data-tooltip-content="Add App" className="btn btn-icon btn-primary ms-2" data-bs-toggle="modal" data-bs-target="#exampleModal" id='addStaffbtn' ><i className="ri-add-line"></i></button>
            )}   */}
        </div>
    </div>
</div>

<div className='container-fluid mt-3'>
<div className='row'>

<div style={{ textAlign: 'center' }}>
  {loading && (
    <div id="searchLoader" className="lds-ellipsis" style={{ color: '#333' }}>
      <div></div><div></div><div></div><div></div>
    </div>
  )}
</div> 

<div id="noDataMessage" style={{ textAlign: 'center', marginTop: '1rem', display: 'none' }}>
  <p className="text-muted">No records found</p>
</div>

 {staff && staff.length > 0 ? (
  staff.map((pro, index) => (
<div className={"col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 bhai1"} key={index}>
<div className="card custom-card mb-4" style={{marginBlockEnd:'0rem',cursor:'pointer',borderColor:'rgb(215, 217, 229)',boxShadow:'rgb(168 171 189 / 97%) 0px 5px 10px 3px'}} data-tooltip-id="global-tooltip" data-tooltip-content="View Detail">
<div className="card-body">
<div className="d-flex align-items-top">

<div className="me-3" onClick={()=>{showLink(pro.id,pro.url,pro.okay)}}>
<span className="avatar bg-outline-primary"> <i className={pro.icon+" fs-32"}></i> </span>
</div>
<div className="flex-fill" onClick={()=>{showLink(pro.id,pro.url,pro.okay)}}>
<h6 className="fw-semibold d-block mb-2 body-text"> {pro.name}</h6>
<span className="fw-semibold d-flex gap-2 align-items-center">
<i className='ri-calendar-2-fill text-primary fs-16'></i>
<span>{pro.date}</span>
</span>

</div>

<div style={{flexDirection:'column',gap:'6px',justifyContent:'end'}} className='d-flex align-items-end'>
   {/* <a aria-label="anchor" style={{marginTop:'-3px',display:'inline-block'}} href="javascript:void(0);" className="text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots fs-19"></i></a>
    <ul className="dropdown-menu">
        <li className="mb-0"><button className="dropdown-item" onClick={()=>{DeleteData(pro.id)}}>Delete</button></li>
        <li className="mb-0"><button className="dropdown-item" onClick={()=>{EditData(pro.id)}}>Edit</button></li>
        <li className="mb-0"><Link className="dropdown-item" to={`/admin/${pro.url}/${pro.id}${pro.okay}`} target="_blank" >View Details</Link></li>
    </ul> */}
    <button className="btn btn-success btn-sm" onClick={() => {setLogOpen(true); setSelectedIndex(index + 1);}}>
      View Logs</button>
    
    <p className="mb-0" > <span className={`badge bg-${pro.status === "Active" ? "primary" : "danger"}-transparent fs-13`}>{pro.status}</span></p>

</div>

        </div>
    </div>
</div>
</div>
  ))
) : null}

</div>
</div>
 </div>
 </div>
</>
);
}
export default Category;